import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = 'https://obvklrhbfipibfysmmye.supabase.co';
export const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9idmtscmhiZmlwaWJmeXNtbXllIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMwMjMwNDUsImV4cCI6MjA4ODU5OTA0NX0.qsk2FfrPn1BA_DQf-K_kQpGtCj4yjU1Lq9b-DmxrRqk';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
